import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent {

  features = [
    {
      icon: '📅',
      title: 'Agenda Inteligente',
      description: 'Sistema completo de agendamento com visualização diária, semanal e mensal. Sincronização automática com Google Calendar.'
    },
    {
      icon: '📋',
      title: 'Prontuário Eletrônico',
      description: 'Prontuário digital completo com histórico clínico, evoluções, anexos de exames e geração de PDF. Tudo seguro e organizado.'
    },
    {
      icon: '👥',
      title: 'Gestão de Pacientes',
      description: 'Cadastro completo de pacientes com CPF, endereço, histórico de consultas e muito mais. Busca rápida e intuitiva.'
    },
    {
      icon: '💰',
      title: 'Controle Financeiro',
      description: 'Gestão completa de contas a pagar e receber, categorias, centros de custo, fornecedores e contas bancárias.'
    },
    {
      icon: '💬',
      title: 'WhatsApp Automático',
      description: 'Confirmações automáticas via WhatsApp. Reduza faltas e otimize sua agenda com lembretes personalizados.'
    },
    {
      icon: '📊',
      title: 'Dashboard e Relatórios',
      description: 'Acompanhe métricas importantes: consultas realizadas, receita mensal, taxa de confirmação e muito mais.'
    },
    {
      icon: '👨‍⚕️',
      title: 'Multi-profissional',
      description: 'Sistema preparado para clínicas com múltiplos profissionais. Gestão de permissões e convites para colaboradores.'
    },
    {
      icon: '🔒',
      title: 'Segurança LGPD',
      description: 'Dados criptografados e armazenados com segurança. Totalmente em conformidade com a LGPD e boas práticas de privacidade.'
    },
    {
      icon: '🌐',
      title: 'Acesse de Qualquer Lugar',
      description: 'Sistema 100% online. Acesse do computador, tablet ou celular. Seus dados sempre sincronizados na nuvem.'
    }
  ];

  plans = [
    {
      name: 'Plano Profissional',
      price: '39,90',
      period: '/mês',
      features: [
        '✨ 30 dias de teste grátis',
        '📅 Agenda ilimitada',
        '👥 Pacientes ilimitados',
        '📋 Prontuário eletrônico completo',
        '💰 Gestão financeira completa',
        '💬 Confirmações via WhatsApp',
        '🔗 Integração Google Calendar',
        '📊 Dashboard com estatísticas',
        '🔒 Segurança e LGPD',
        '📱 Acesso mobile',
        '💪 Suporte prioritário',
        '🚀 Atualizações automáticas'
      ],
      highlight: true
    }
  ];

  testimonials = [
    {
      name: 'Dra. Ana Beatriz',
      specialty: 'Psicóloga Clínica',
      photo: '👩‍⚕️',
      text: 'A ClinixCore transformou minha prática! O prontuário eletrônico é completo e a gestão financeira me deu controle total sobre o consultório. Recomendo demais!'
    },
    {
      name: 'Dr. Carlos Eduardo',
      specialty: 'Fisioterapeuta',
      photo: '👨‍⚕️',
      text: 'Excelente custo-benefício! As confirmações automáticas via WhatsApp reduziram minhas faltas em 80%. O sistema é intuitivo e fácil de usar.'
    },
    {
      name: 'Dra. Juliana Mendes',
      specialty: 'Nutricionista',
      photo: '👩‍⚕️',
      text: 'Uso a ClinixCore há 6 meses e não me vejo sem ela! O prontuário digital com anexos de exames facilitou muito meu trabalho. Vale cada centavo!'
    }
  ];

  faqs = [
    {
      question: 'Como funciona o período de teste?',
      answer: 'Você tem 30 dias de teste grátis, sem necessidade de cartão de crédito. Explore todas as funcionalidades e cancele quando quiser, sem custos.',
      open: false
    },
    {
      question: 'Qual é o valor após o período de teste?',
      answer: 'Após os 30 dias grátis, o plano custa R$ 39,90 por mês, por profissional. Sem taxa de adesão ou custos ocultos.',
      open: false
    },
    {
      question: 'Posso cancelar a qualquer momento?',
      answer: 'Sim! Não há fidelidade ou multa. Você pode cancelar sua assinatura a qualquer momento direto no sistema, sem burocracia.',
      open: false
    },
    {
      question: 'Quantos pacientes e consultas posso cadastrar?',
      answer: 'Não há limite! Cadastre quantos pacientes você precisar e agende quantas consultas desejar, sem custos adicionais.',
      open: false
    },
    {
      question: 'Os dados são seguros?',
      answer: 'Sim! Utilizamos criptografia SSL, backups automáticos diários e estamos em conformidade com a LGPD. Seus dados estão protegidos e seguros.',
      open: false
    },
    {
      question: 'Como funcionam as confirmações via WhatsApp?',
      answer: 'O sistema envia automaticamente mensagens de lembrete e confirmação via WhatsApp antes das consultas. Você configura os horários e textos personalizados.',
      open: false
    },
    {
      question: 'Posso usar em clínicas com vários profissionais?',
      answer: 'Sim! O sistema é multi-profissional. Você pode convidar outros profissionais (secretárias, médicos) e gerenciar permissões de acesso.',
      open: false
    },
    {
      question: 'Funciona no celular?',
      answer: 'Sim! O sistema é 100% responsivo e funciona perfeitamente em computadores, tablets e celulares. Acesse de qualquer lugar.',
      open: false
    }
  ];

  constructor(private router: Router) {}

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  toggleFaq(index: number) {
    this.faqs[index].open = !this.faqs[index].open;
  }

  startTrial() {
    this.router.navigate(['/login']);
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}
